import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
import { RoleGuard } from 'client/app/guards/role.guard';

import { MyDocumentComponent } from './my-document/my-document.component';
import { MyDocumentsListComponent } from './my-documents-list/my-documents-list.component';

const routes: Routes = [
	{
		path: '',
		component: MyDocumentsListComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.basicUserRole },
		resolve: []
	},
	{
		path: ':id',
		component: MyDocumentComponent,
		canActivate: [RoleGuard],
		data: { role: AppConstants.basicUserRole },
		resolve: []
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class MyDocumentsRoutingModule { }
